import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import { getCurrentInstance, ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import { formatNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { statusFilter, invoiceType } = PaymentModuleUtils
let { 
  // 发票认证_条件查询
  'POST/invoice/confirm_conditions': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    label: "公司",
    value: '',
    upKey: 'payeeCompany',
    props: { clearable : true }
  },
  {
    type: "TIME",
    label: "日期",
    value: [],
    upKey: 'date',
    upProps: {startKey: 'from', endKey: 'to'},
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD'
    }
  },
])
const searchHandle = (params: any) => {
  fetchData({
    query: {
      ...params,
      certifiedAt: {
        from: params.from,
        to: params.to,
      }
    }
  })
}
// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => { }

// 删除
const delHandle = (row: any) => { }


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "发票认证-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "CO单号",
          prop: "no",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发起人",
          prop: "creator",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "company",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "费用归属部门",
          prop: "department",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "费用类型",
          prop: "reimburseType",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票类型",
          prop: "invoiceType",
          width: "110",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(invoiceType)(row.invoiceType as any)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "发票代码",
          prop: "invoiceCode",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票号码",
          prop: "invoiceNo",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票日期",
          prop: "invoiceDate",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "摘要",
          prop: "summary",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "总金额",
          prop: "totalAmount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "税率",
          prop: "taxRate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "税额",
          prop: "taxAmount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "不含税金额",
          prop: "taxExcluded",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "进项税额",
          prop: "inputTaxAmount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付费用",
          prop: "amount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "余额",
          prop: "invoiceBalance",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付时间",
          prop: "payAt",
          width: "110",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createTime",
          width: "110",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "审批状态",
          prop: "approvedStatus",
          width: "110",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(statusFilter)(row.approvedStatus)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "urgent",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})